import React, { useState, useEffect } from 'react';
import '../css/AdminBuyers.css';
import '../css/RateExchange.css';
import { Link , useHistory } from 'react-router-dom';
import Image from '../Images/logo.png';
import { GiHamburgerMenu } from 'react-icons/gi';
import { GiSplitCross } from 'react-icons/gi';
import { FaExchangeAlt } from 'react-icons/fa';
import axios from 'axios';

const RateExchange = () => {
    const history = useHistory();
    const [admin, setAdmin] = useState(false);
    const [disp, setDisp] = useState("none");
    const [usd , setUsd] = useState("");
    const [cny , setCny] = useState("");
    const [eur , setEur] = useState("");
    const [gbp , setGbp] = useState("");
    useEffect(() => {
        const loginstatus = localStorage.getItem("_trisquarestorage")
        if (loginstatus) {
            const newValue = JSON.parse(loginstatus)
            newValue.data[0].email === "buyer@trisquare.asia" ? setAdmin(true) : setAdmin(false);
        } else {
            setAdmin(false)
        }
    }, [])
    const handleToggle = () => {
        if (disp === "none") {
            setDisp("block")
        } else {
            setDisp("none")
        }
    }
    const change_currency = (e) => {
        axios.post("https://trisquare.asia/api/rate_exchange/update", {
            usd,
            cny,
            eur,
            gbp
        }).then(response => {
            history.push("/buyer/admin/rateExchange");
        })
        // setUsd("");
        // setEur("");
        // setCny("");
        // setGbp("");
        // console.log(usd);
        // console.log(cny);
        // console.log(eur);
        // console.log(gbp);
    };

    if (admin) {
        return (
            <div className="admin">
                <p id="timers">
                    <span className="spans" id="timer-days"></span>
                    <span className="spans" id="timer-hours"></span>
                    <span className="spans" id="timer-mins"></span>
                    <span className="spans" id="timer-secs"></span>
                </p>
                <div className="hamburgerIcon" onClick={handleToggle}>
                    {
                        disp === "none" ? <GiHamburgerMenu className="hamIcon" /> : <GiSplitCross className="crossIcon" />
                    }
                </div>
                <div className="admin__navbar extraNavbar">
                    <Link to='/buyer/admin' className="admin__navbarOption"><h4>Home</h4></Link>
                    <Link to='/buyer/admin/preorders' className="admin__navbarOption"><h4>Pre-Orders</h4></Link>
                    <Link to='/buyer/admin/purchases' className="admin__navbarOption"><h4>Purchases</h4></Link>
                    <Link to='/buyer/admin/requests' className="admin__navbarOption"><h4>Product Requests</h4></Link>
                    <Link to='/buyer/admin/verifyUser' className="admin__navbarOption"><h4>Verify Users</h4></Link>
                    <Link to='/buyer/admin/buyers' className="admin__navbarOption "><h4>All Buyers</h4></Link>
                    <Link to='/buyer/admin/sellers' className="admin__navbarOption"><h4>All Sellers</h4></Link>
                    <Link to='/buyer/admin/rateExchange' className="admin__navbarOption active"><h4>RateExchange</h4></Link>
                    <img src={Image} className="admin__image" />
                </div>
                <div className="admin__navbar" style={{ display: `${disp}`, transition: "0.3s" }}>
                    <Link to='/buyer/admin' className="admin__navbarOption"><h4>Home</h4></Link>
                    <Link to='/buyer/admin/preorders' className="admin__navbarOption"><h4>Pre-Orders</h4></Link>
                    <Link to='/buyer/admin/purchases' className="admin__navbarOption"><h4>Purchases</h4></Link>
                    <Link to='/buyer/admin/requests' className="admin__navbarOption"><h4>Product Requests</h4></Link>
                    <Link to='/buyer/admin/verifyUser' className="admin__navbarOption"><h4>Verify Users</h4></Link>
                    <Link to='/buyer/admin/buyers' className="admin__navbarOption active"><h4>All Buyers</h4></Link>
                    <Link to='/buyer/admin/sellers' className="admin__navbarOption"><h4>All Sellers</h4></Link>
                    <Link to='/buyer/admin/rateExchange' className="admin__navbarOption active"><h4>RateExchange</h4></Link>
                    <img src={Image} className="admin__image" />
                </div>
                <div className="admin__mainPage">
                    <h4 className="admin__heading">Currency Exchange Rates</h4>
                    <form className="rateExchange__form">
                        <div className="rateExchange__div">
                            <div className="rateExchange__span1">
                                1USD
                            </div>
                            <div className="rateExchange__icon">
                                <FaExchangeAlt />
                            </div>
                            <div className="rateExchange__span1">
                                <input type="text" className="rateExchange__input" name="usd" value = {usd} onChange = {(e) => setUsd(e.target.value)} />
                                USD
                            </div>
                        </div>
                        <div className="rateExchange__div">
                            <div className="rateExchange__span1">
                                1CNY
                            </div>
                            <div className="rateExchange__icon">
                                <FaExchangeAlt />
                            </div>
                            <div className="rateExchange__span1">
                                <input type="text" className="rateExchange__input" name="cny" value = {cny} onChange = {(e) => setCny(e.target.value)}/>
                                USD
                            </div>
                        </div>
                        <div className="rateExchange__div">
                            <div className="rateExchange__span1">
                                1EUR
                            </div>
                            <div className="rateExchange__icon">
                                <FaExchangeAlt />
                            </div>
                            <div className="rateExchange__span1">
                                <input type="text" className="rateExchange__input" name="eur" value = {eur} onChange = {(e) => setEur(e.target.value)}/>
                                USD
                            </div>
                        </div>
                        <div className="rateExchange__div">
                            <div className="rateExchange__span1">
                                1GBP
                            </div>
                            <div className="rateExchange__icon">
                                <FaExchangeAlt />
                            </div>
                            <div className="rateExchange__span1">
                                <input type="text" className="rateExchange__input" name="gbp" value = {gbp} onChange = {(e) => setGbp(e.target.value)}/>
                                USD
                            </div>
                        </div>
                        <div className="rateExchange__div">
                            <button type="submit" onClick = {change_currency} className="rateExchange__submitButton">SUBMIT</button>
                        </div>
                    </form>
                </div>
            </div>
        )
    } else {
        return <div>Page Not Found</div>
    }
}
export default RateExchange;